import { CheckListItem as CheckListItemComponent } from "components/atoms/CheckListItem";
import React from "react";
//====================================================================
import { types, Text } from "react-bricks/frontend";
import TextBlock from "../common/TextBlock";

interface ChecklistItemProps {
  value: types.TextValue;
}

const ChecklistItem: types.Brick<ChecklistItemProps> = () => {
  return (
    <CheckListItemComponent compact={true} title={null}>
      <TextBlock
        propName="text"
        placeholder="Type a title..."
        renderBlock={({ children }) => <span>{children}</span>}
        renderPlaceholder={({ children }) => <span>{children}</span>}
      />
    </CheckListItemComponent>
  );
};

ChecklistItem.schema = {
  // Unique brick name
  name: "checklist-item",
  label: "Checklist Item",
  hideFromAddMenu: true,
  // Defaults when a new brick is added
  getDefaultProps: () => ({
    value: "Thick as a brick",
  }),

  // Sidebar Edit controls for props
  sideEditProps: [],
};

export default ChecklistItem;
